import dayjs from 'dayjs'
import { Team } from '../types/Team'

export function hasOngoingMeeting({ endDate, team }: { endDate?: string; team?: Team }) {
  return endDate && dayjs(team?.metaData?.wherebyMeeting?.endDate).isAfter(dayjs())
}
